import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { replaceSpecialCh } from "../../Helpers";
import ConfirmDialoag from "../common/ConfirmDialoag";
import Button from "../common/Button";
import {
  Grid,
  Paper,
  Table as MuiTable,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Collapse,
  IconButton,
  Checkbox,
  FormControlLabel,
  Tooltip,
} from "@mui/material";
import TextField from "../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import Style from "style-it";

import moment from "moment";
import Loader from "../../Layout/Loader";

// refNum:replaceSpecialCh(data.refNum || ''),
const makeSubType = (data, parentId) => ({
  // ...data,
  expensetypeId: data.expensetypeId,
  id: data.id || "",
  label: replaceSpecialCh(data.itemName || ""),
  modified: null,
  modifiedBy: null,
  parentId: parentId,
  purchasePrice:
    data && data.purchasePrice ? parseFloat(data.purchasePrice) : 0, //itemTotalAmount
  subTypeGroup: data.subTypeGroup || "",
  subTypeNum: replaceSpecialCh(data.itemCode || ""),
  unitPrice: data.itemPrice || "",
  generic: false,
  attributes: data.attributes || {},
});
let source;
class itemsList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editOption: false,
      form: {
        expensetypeId: "",
        attributes: {
          quantityPriceScale: [{ quantity: "", price: "" }],
        },
      },
      isVisible: false,
      quantityError: "",
      itemAlredyExists: "",
      showGrid: false,
      deleteRow: false,
    };
  }

  handleAddMore = () => {
    const { form } = this.state;
    const { quantityPriceScale } = form.attributes;

    const updatedQuantityPriceScale = [
      ...quantityPriceScale,
      { quantity: "", price: "" },
    ];

    const updatedForm = {
      ...form,
      attributes: {
        ...form.attributes,
        quantityPriceScale: updatedQuantityPriceScale,
      },
    };

    this.setState({ form: updatedForm });
  };

  onCancel1 = () => {
    this.setState({
      deleteRow: false,
    });
  };
  // handleDelete = index => {
  //   const { form } = this.state;
  //   const updatedForm = { ...form };
  //   updatedForm.attributes.quantityPriceScale.splice(index, 1);
  //   this.setState({ form: updatedForm });
  // };

  handleDelete = (index) => {
    const { form } = this.state;
    const updatedForm = { ...form };
    if (updatedForm?.attributes?.quantityPriceScale?.length > 1) {
      updatedForm.attributes.quantityPriceScale.splice(index, 1);
      this.setState({ form: updatedForm });
    } else {
      // Display a message or perform any other action when attempting to delete the last row
      this.setState({
        deleteRow: true,
      });
    }
  };
  handleChange = (name) => (event) => {
    let val;
    if (name === "itemTotalAmount" || name === "itemPrice") {
      val = parseFloat(event.target.value);
    } else {
      val = event.target.value;
    }
    this.setState(
      {
        form: {
          ...this.state.form,
          [name]: val,
        },
      },
      () => {
        this.checkRequiredFields();
      },
    );
  };

  checkRequiredFields = () => {
    const { itemTotalAmount } = this.state.form;
    const { quantityError, itemAlredyExists, showGrid } = this.state;
    if (showGrid) {
      if (!quantityError && !itemAlredyExists) {
        this.setState({ isVisible: true });
      } else {
        this.setState({ isVisible: false });
      }
    } else {
      if (!itemAlredyExists) {
        this.setState({ isVisible: true });
      } else {
        this.setState({ isVisible: false });
      }
    }
  };

  handleQuntityPriceScale = () => {
    this.setState({ showGrid: !this.state.showGrid });
  };

  modalControle = () => {
    this.setState(
      {
        editOption: false,
        showGrid: false,
      },
      // () => this.props.closeModale()
    );
  };

  openModale = (item) => {
    // Destructure the item to get the necessary data
    const { contractNumber, categoryName, itemCode } = item[0];

    // Create the URLs for the two API calls
    const apiUrl = `/api/expensetypes/get?contractNumber=${contractNumber}&all=true`;
    const apiUrl2 = `/api/deliverynotes/items/incontract?contractnumber=${contractNumber}&categoryname=${categoryName}&subtypenum=${itemCode}`;

    source = axios.CancelToken.source();

    // Use axios.all to make multiple API requests together
    axios
      .all([
        axios.get(apiUrl, { cancelToken: source.token }),
        axios.get(apiUrl2, { cancelToken: source.token }),
      ])
      .then(
        axios.spread((response1, response2) => {
          // Process the responses of both API calls here
          const allAccounts = response1.data?.data?.data || [];
          const matchedAccount = allAccounts.find(
            (account) => account.description === categoryName,
          );
          const expenseTypeId = matchedAccount ? matchedAccount.id : null;

          const userAccount = this.props.accounts?.data.find(
            (account) => account.contractNumber === contractNumber,
          );
          const updatedItem = {
            ...item[0],
            accountName: userAccount?.label,
          };
          this.setState({
            editOption: true,
            itemAlredyExists: response2.data.data,
            isVisible:
              response2 && response2.data && response2.data.data ? false : true,
            form: {
              ...updatedItem,
              expensetypeId: expenseTypeId,
              purchasePrice: item[0]?.itemPrice || 0,
              attributes: {
                quantityPriceScale: [{ quantity: "", price: "" }],
              },
            },
          });
        }),
      )
      .catch((e) => {
        console.log("Error:", e);
      });
  };

  submitForm = () => {
    let url = `/api/expensetypes/subtype`;
    let updatedPayload;
    if (
      Object.keys(this.state.form.attributes.quantityPriceScale).length === 0
    ) {
      updatedPayload = {
        ...this.state.form,
        attributes: {
          // quantityPriceScale: { NaN: null },
          quantityPriceScale: { 0: 0 },
        },
      };
    } else {
      updatedPayload = {
        ...this.state.form,
        attributes: {
          quantityPriceScale:
            this.state.form?.attributes?.quantityPriceScale?.reduce(
              (acc, item) => {
                acc[item.quantity] = item.price;
                return acc;
              },
              {},
            ),
        },
      };
    }
    // Convert empty strings to 0 and ensure values are numbers
    Object.keys(updatedPayload.attributes.quantityPriceScale).forEach((key) => {
      if (updatedPayload.attributes.quantityPriceScale[key] === "") {
        updatedPayload.attributes.quantityPriceScale[key] = 0;
      } else {
        updatedPayload.attributes.quantityPriceScale[key] = parseFloat(
          updatedPayload.attributes.quantityPriceScale[key],
        );
      }
    });

    // Convert the keys to numbers (if they are not already) and handle NaN keys
    updatedPayload.attributes.quantityPriceScale = Object.keys(
      updatedPayload.attributes.quantityPriceScale,
    ).reduce((acc, key) => {
      const numericKey = parseFloat(key);
      acc[Number.isNaN(numericKey) ? 0 : numericKey] =
        updatedPayload.attributes.quantityPriceScale[key];
      return acc;
    }, {});

    let parentId = this.props?.logInUser?.id;
    const obj1 = makeSubType(updatedPayload, parentId);

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(obj1),
    })
      .then((response) => {
        if (response.ok) {
          this.setState(
            {
              form: {
                expensetypeId: this.props?.selectedServiceTypeId,
                attributes: {
                  quantityPriceScale: [{ quantity: "", price: "" }],
                },
              },
              editOption: false,
            },
            () => {
              this.props.getMissingItems();
            },
          );

          toast.success(this.props.translate("subTypeCreated"));
        }
      })
      .catch((error) => {
        console.log("error ==", error);
      });
  };

  regenerateDeliveryNote = (item, type) => {
    let api = `/api/deliverynotes/${item[0].deliveryNoteId}/recompute`;
    axios({
      method: "GET",
      url: api,
    })
      .then((response) => {
        if (response?.data.status === "success") {
          toast.success(this.props.translate("itemNoteRegeneatedSuccessFul"));
          this.setState({}, () => {
            this.props.getMissingItems();
          });
        } else {
          toast.error(this.props.translate(response?.data?.message));
        }
      })
      .catch((error) => {
        toast.error(this.props.translate("somethingWentWrong"));
      });
  };
  handleChange1 = (index, field, value) => {
    const { form } = this.state;
    const updatedForm = { ...form };

    // Update the quantity or price value with parseFloat
    updatedForm.attributes.quantityPriceScale[index][field] = parseFloat(value);

    // Check for duplicate entries
    const quantities = updatedForm.attributes.quantityPriceScale.map(
      (item) => item.quantity,
    );
    const hasDuplicates = new Set(quantities).size !== quantities.length;

    if (hasDuplicates) {
      this.setState(
        {
          quantityError: "Duplicate entry",
          quantityHelperText: "Please enter unique quantities",
        },
        () => this.checkRequiredFields(),
      );
      return;
    } else {
      this.setState(
        {
          quantityError: "",
          quantityHelperText: "",
        },
        () => this.checkRequiredFields(),
      );
    }

    this.setState({ form: updatedForm }, () => this.checkRequiredFields());
  };

  getGroupCount = (group) => (group.count != null ? group.count : "-");

  formatStatusValue = (row) => {
    const { translate } = this.props;
    const completed = row.completed;

    if (completed === true || completed === 1 || completed === "true") {
      return translate("completed");
    }

    if (completed === false || completed === 0 || completed === "false") {
      return translate("incomplete");
    }

    return "";
  };

  formatCellValue = (columnId, row) => {
    if (columnId === "status") {
      return this.formatStatusValue(row);
    }
    const value = row[columnId];
    if (
      columnId === "lastServiceDate" ||
      columnId === "nextExecutionDate" ||
      columnId === "completedAt"
    ) {
      return this.formatDateValue(value);
    }
    if (value === null || value === undefined || value === "") {
      return "";
    }
    return value;
  };

  formatDateValue = (value) => {
    if (!value) {
      return "";
    }
    return moment.utc(value).format("DD/MM/YYYY");
  };

  renderGroupedPagination = () => {
    const pagination = this.props.setPagination();
    if (!pagination) {
      return null;
    }

    return (
      <div
        style={{
          padding: "0 20px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span style={{ marginRight: 10 }} className="hidden-xs">
          {this.props.translate("rowsPerPage")}
        </span>
        <span style={{ marginRight: 10, minWidth: 60 }}>
          <TextField
            id="rowsPerPage"
            select
            style={{ width: 60 }}
            value={pagination.pageSize || 20}
            onChange={(e) => this.props.handleChangeRowsPerPage(e.target.value)}
            margin="dense"
          >
            {[5, 10, 15, 20, 25, 50, 100].map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        </span>
        <span style={{ flex: 1 }}></span>
        <span style={{ marginRight: 5, whiteSpace: "nowrap" }}>
          {this.props.translate("page")} <strong>{pagination.page}</strong> /{" "}
          {pagination.lastPage}
        </span>
        <span style={{ marginRight: 10 }}>
          {this.props.translate("totalRecords")}{" "}
          <strong>{pagination.total}</strong>
        </span>
        <IconButton size="small" onClick={() => this.props.handleChangePage(1)}>
          <FirstPageIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          onClick={() =>
            this.props.handleChangePage(Math.max((pagination.page || 1) - 1, 1))
          }
        >
          <NavigateBeforeIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          disabled={!pagination.hasNext}
          onClick={() =>
            this.props.handleChangePage((pagination.page || 1) + 1)
          }
        >
          <NavigateNextIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          disabled={!pagination.hasNext}
          onClick={() => this.props.handleChangePage(pagination.lastPage)}
        >
          <LastPageIcon fontSize="small" />
        </IconButton>
      </div>
    );
  };

  renderGroupedTable = () => {
    const {
      groupedRows = [],
      expandedGroups = {},
      groupDetails = {},
      groupDetailsLoading = {},
      toggleGroup,
      loadMoreGroupDetails,
      getGroupKey,
      translate,
    } = this.props;

    const detailColumns = [
      { id: "categoryName", label: translate("categoryName") },
      { id: "itemCode", label: translate("itemCode") },
      { id: "lastServiceDate", label: translate("serviceDate") },
      { id: "nextExecutionDate", label: translate("nextExecutionDate") },
      { id: "odometerReading", label: translate("serviceOdometer") },
      { id: "nextOdometerReading", label: translate("nextOdometerReading") },
      { id: "businessPotential", label: translate("businessPotential") },
      { id: "completedAt", label: translate("completedAt") },
      { id: "status", label: translate("status") },
    ];

    if (!groupedRows.length) {
      return (
        <Paper style={{ margin: "10px", padding: "24px", textAlign: "center" }}>
          {translate("noRecordFound")}
        </Paper>
      );
    }

    return (
      <Paper style={{ margin: "10px", overflow: "hidden" }}>
        <MuiTable size="small">
          <TableHead>
            <TableRow>
              <TableCell style={{ width: 48 }} />
              <TableCell>{translate("contractNumber")}</TableCell>
              <TableCell>{translate("plateNumber")}</TableCell>
              <TableCell align="right">
                {translate("predictionCount")}
              </TableCell>
              <TableCell align="right">{translate("totalPotential")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {groupedRows.map((group) => {
              const key = getGroupKey(group);
              const isExpanded = !!expandedGroups[key];
              const detail = groupDetails[key];
              const isLoading = !!groupDetailsLoading[key];
              const contractNumber = group.contractNumber || group.cn || "";
              const plateNumber = group.plateNumber || group.plateNo || "";

              return (
                <React.Fragment key={key}>
                  <TableRow
                    hover
                    style={{
                      cursor: "pointer",
                      background: isExpanded ? "#f7f9fc" : "inherit",
                    }}
                    onClick={() => toggleGroup(group)}
                  >
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={(event) => {
                          event.stopPropagation();
                          toggleGroup(group);
                        }}
                      >
                        {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                      </IconButton>
                    </TableCell>
                    <TableCell>{contractNumber}</TableCell>
                    <TableCell>{plateNumber}</TableCell>
                    <TableCell align="right">
                      {this.getGroupCount(group)}
                    </TableCell>
                    <TableCell align="right">
                      {group.totalPotential != null
                        ? group.totalPotential
                        : "-"}
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      colSpan={5}
                      style={{ padding: 0, borderBottom: 0 }}
                    >
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
                        <div
                          style={{
                            padding: "8px 16px 16px 56px",
                            background: "#fafafa",
                          }}
                        >
                          {isLoading && !detail?.data?.length ? (
                            <Loader component="filter" />
                          ) : (
                            <>
                              <MuiTable size="small">
                                <TableHead>
                                  <TableRow>
                                    {detailColumns.map((column) => (
                                      <TableCell key={column.id}>
                                        {column.label}
                                      </TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {(detail?.data || []).map((row, index) => (
                                    <TableRow key={`${key}-${index}`}>
                                      {detailColumns.map((column) => (
                                        <TableCell key={column.id}>
                                          {this.formatCellValue(column.id, row)}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  ))}
                                  {!detail?.data?.length && !isLoading ? (
                                    <TableRow>
                                      <TableCell colSpan={detailColumns.length}>
                                        {translate("noRecordFound")}
                                      </TableCell>
                                    </TableRow>
                                  ) : null}
                                </TableBody>
                              </MuiTable>
                              {detail?.hasNext ? (
                                <div
                                  style={{ marginTop: 12, textAlign: "center" }}
                                >
                                  <Button
                                    size="small"
                                    variant="outlined"
                                    disabled={isLoading}
                                    onClick={() => loadMoreGroupDetails(group)}
                                  >
                                    {translate("loadMore")}
                                  </Button>
                                </div>
                              ) : null}
                            </>
                          )}
                        </div>
                      </Collapse>
                    </TableCell>
                  </TableRow>
                </React.Fragment>
              );
            })}
          </TableBody>
        </MuiTable>
        {this.renderGroupedPagination()}
      </Paper>
    );
  };

  render() {
    const { tab, themecolors } = this.props;

    return (
      <div>
        <Style>{`
          .custom-tab-button {
            min-height: 29px;
            border-radius: 6px 6px 0 0;
            margin: 0 2px;
            background: ${this.props.themecolors["600"]};
            color: ${this.props.themecolors["themeInverse"]};
          }
          .custom-tabs {
            min-height: 30px;
            margin: 10px 6px 0;
          }

          .custom-tab-button-selected {
            background: ${this.props.themecolors["500"]};
            color: ${this.props.themecolors["themeInverse"]};
          }`}</Style>

        <Grid
          container
          className="breadcrumb-row"
          style={{ paddingLeft: 10, paddingRight: 10 }}
        >
          <Grid item xs={5} sm={5} style={{ display: "flex" }}>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => this.props.handleChangeTabs("missedOpportunity")}
              style={{
                width: "50%",
                borderTopRightRadius: " 15px",
                borderTopLeftRadius: "15px",
                marginLeft: "5px",
                backgroundColor:
                  tab === "missedOpportunity"
                    ? themecolors.themeLightColor
                    : "#ffff",
                color:
                  tab === "missedOpportunity"
                    ? "#ffff"
                    : themecolors.themeLightColor,
              }}
            >
              {this.props.translate("Missed Opportunities")}
            </Button>

            <Button
              variant="contained"
              disabled={false}
              onClick={() =>
                this.props.handleChangeTabs("potentialOpportunity")
              }
              style={{
                width: "50%",
                borderTopRightRadius: " 15px",
                borderTopLeftRadius: "15px",
                marginLeft: "5px",
                backgroundColor:
                  tab === "potentialOpportunity"
                    ? themecolors.themeLightColor
                    : "#ffff",
                color:
                  tab === "potentialOpportunity"
                    ? "#ffff"
                    : themecolors.themeLightColor,
              }}
            >
              {" "}
              {this.props.translate("Potential Opportunities")}
            </Button>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ padding: "10px 10px 0", width: "100%" }}
        >
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              label={this.props.translate("plateNo")}
              value={this.props.plateNo || ""}
              onChange={this.props.handleFilterChange("plateNo")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              label={this.props.translate("category")}
              value={this.props.category || ""}
              onChange={this.props.handleFilterChange("category")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              label={this.props.translate("itemCode")}
              value={this.props.itemCode || ""}
              onChange={this.props.handleFilterChange("itemCode")}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              select
              fullWidth
              label={this.props.translate("completed")}
              value={
                this.props.completed === undefined ||
                this.props.completed === null
                  ? 2
                  : this.props.completed
              }
              onChange={this.props.handleFilterChange("completed")}
            >
              <MenuItem value={2}>{this.props.translate("all")}</MenuItem>
              <MenuItem value={1}>{this.props.translate("true")}</MenuItem>
              <MenuItem value={0}>{this.props.translate("false")}</MenuItem>
            </TextField>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              select
              fullWidth
              label={this.props.translate("wanted")}
              value={
                this.props.wanted === undefined || this.props.wanted === null
                  ? 2
                  : this.props.wanted
              }
              onChange={this.props.handleFilterChange("wanted")}
            >
              <MenuItem value={2}>{this.props.translate("all")}</MenuItem>
              <MenuItem value={1}>{this.props.translate("true")}</MenuItem>
              <MenuItem value={0}>{this.props.translate("false")}</MenuItem>
            </TextField>
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}
          >
            <Button
              variant="contained"
              color="secondary"
              size="small"
              onClick={this.props.applyFilters}
            >
              {this.props.translate("submit")}
            </Button>
            <Button
              variant="outlined"
              size="small"
              onClick={this.props.clearFilters}
            >
              {this.props.translate("clear")}
            </Button>{" "}
            {tab === "missedOpportunity" && (
              <>
                <Tooltip
                  title={this.props.translate(
                    "overDueWillShowPrevious30DaysPredictions",
                  )}
                >
                  <FormControlLabel
                    style={{ marginLeft: 0, marginRight: 0 }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={!!this.props.overDueRangeEnabled}
                        onChange={(e) =>
                          this.props.handleToggleOverDueRange?.(
                            e.target.checked,
                          )
                        }
                      />
                    }
                    // label={this.props.translate(
                    //   "vehicleServicesOverDueCheckbox",
                    // )}
                  />
                </Tooltip>
              </>
            )}
            {tab === "potentialOpportunity" && (
              <>
                <Tooltip
                  title={this.props.translate(
                    "dueWillShowNext30DaysPredictions",
                  )}
                >
                  <FormControlLabel
                    style={{ marginLeft: 0, marginRight: 0 }}
                    control={
                      <Checkbox
                        color="primary"
                        checked={!!this.props.dueRangeEnabled}
                        onChange={(e) =>
                          this.props.handleToggleDueRange?.(e.target.checked)
                        }
                      />
                    }
                    // label={this.props.translate("vehicleServicesDueCheckbox")}
                  />
                </Tooltip>
              </>
            )}
          </Grid>
        </Grid>
        {this.props.loader2 ? <Loader /> : this.renderGroupedTable()}

        {this.state.onDeleteConfirmation && (
          <ConfirmDialoag
            onCancel={this.onCancel}
            onOk={this.deleteCreditDebit}
            title={this.props.translate("areYouWantToDelete")}
            // children={this.state.selectedUser.name}
          />
        )}
        {this.state.deleteRow && (
          <ConfirmDialoag
            onCancel={this.onCancel1}
            onOk={this.onCancel1}
            title={this.props.translate("cannottDeleteLastRow")}
            // children={this.state.selectedUser.name}
          />
        )}
      </div>
    );
  }
}
const mapState = (state) => {
  const devices = {
    ...state.devices,
    data:
      state.devices.data &&
      state.devices.data.map((d) => {
        if (d.created) {
          if (state.logInUsers.twelveHourFormat) {
            d.created = moment(d.created).format("YYYY-MM-DD hh:mm A");
          } else {
            d.created = moment(d.created).format("YYYY-MM-DD HH:mm");
          }
          return d;
        } else {
          return d;
        }
      }),
  };

  return {
    devices: state.devices,
    logInUser: state.logInUsers,
    group: state.groups,
    themecolors: state.themecolors,
    ServerSetting: state.ServerSetting,
    parentUnitLimits: state.parentUnitLimits,
  };
};

const mapStateToProps = connect(mapState);
export const ItemsList = mapStateToProps(itemsList);
